import React, { Component } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
} from "mdbreact";
import axios from "../../../../axios";
import { DateTimeInput } from "semantic-ui-calendar-react";
import "react-phone-number-input/style.css";
import PhoneInput, {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import { withTranslation } from "react-i18next";
import $ from "jquery";
import SelectSearch, { fuzzySearch } from "react-select-search";
class AddNewGuest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Email: "",
            sms: false,
            voice: false,
            // dateStart: null,
            dateStartToday: Intl.DateTimeFormat("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
            }).format(new Date()),
            dateEnd: null,
            invalidPhone: null,
            invalidDateStart: null,
            loading: false,
            userFound: false,
            userFoundWithPhone: false,
            invalidEmail: undefined,
            email: this.props.email,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            phoneNumber: this.props.phoneNumber,
            selectedLanguage: this.props.selectedLanguage,
            loading_units: false,
            unitForm: this.props.unitForm,
            buildingForm: this.props.buildingForm,
            floorForm: this.props.floorForm,
            selectedFloor: this.props.selectedFloor,
            selectedServicePlanID: this.props.selectedServicePlanID,
            languageOptions: [
                { value: "en-us", name: "English" },
                { value: "es-xl", name: "Spanish" },
            ],
        };
    }
    componentDidMount() {
     this.setStartDate(this.props.venueID);
        // this.props.getVenues();
        if (this.props.fromEndedSubscription === true) {
            // this.props.getVenueDetails(this.props.venueID)
            this.props.handleSelectChangeUnitInitial(this.props.selectedUnit);
            this.props.handleSelectChangeBuilding(
                this.props.selectedBuilding,
                this.props.selectedUnit
            );
            this.props.handleSelectChangeFloor(
                this.props.selectedFloor,
                this.props.selectedUnit,
                this.props.selectedBuilding
            );
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.hasUpdated !== this.props.hasUpdated) {
            this.setState({
                unitForm: this.props.unitForm,
                buildingForm: this.props.buildingForm,
                floorForm: this.props.floorForm,
            });
        }
        if (prevProps.hasUpdatedUnit !== this.props.hasUpdatedUnit) {
            this.setState({
                selectedUnit: this.props.selectedUnit,
                buildingForm: this.props.buildingForm,
            });
        }
        if (prevProps.hasUpdatedBuilding !== this.props.hasUpdatedBuilding) {
            this.setState({
                selectedBuilding: this.props.selectedBuilding,
                floorForm: this.props.floorForm,
            });
        }
        if (prevProps.hasUpdatedFloor !== this.props.hasUpdatedFloor) {
            this.setState({
                selectedFloor: this.props.selectedFloor,
                unitID_internal: this.props.unitID_internal,
            });
        }
    }
    setStartDate = (index) => {
         let body = {
                     AccessToken: sessionStorage.getItem("AccessToken"),
                     VenueID: index,
                     UserTimeZone: new Date().getTimezoneOffset(),
                 };
                 axios
                     .post("/venuemgmtconsole/venues/listVenueDetails", body, {
                         headers: { "api-version": "20260417" },
                     })
                     .then((response) => {
                      this.setState({
                    // unitData:
                    //     response.data[index][
                    //         "Units-Building-Floor-List-GuestNetworks"
                    //     ],
                    timezone: response.data[index]["TimeZoneOffset"], //+4
                    duration:
                        response.data[index][
                            "DefaultSubscriptionDurationHours_LocalWirelessAccess"
                        ],
                });
         var offset =
                        (new Date().getTimezoneOffset() +
                            response.data[index]["TimeZoneOffset"] * 60) *
                        60 *
                        1000;
                    let offsetTimestamp = new Date().getTime() + offset;
                    let offsetDateStart = new Date(offsetTimestamp);
                    this.setState({
                        dateStart: Intl.DateTimeFormat("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(offsetDateStart),
                    });
                    let offsetTimestampNow = new Date().getTime() + offset;
                    let offsetDateStartNow = new Date(offsetTimestampNow);
                    this.setState({
                        dateStart: Intl.DateTimeFormat("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(offsetDateStart),
                    });
                    this.setState({
                        dateStartNow: Intl.DateTimeFormat("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(offsetDateStartNow),
                    });
                    this.setEndDate(
                        offsetDateStart,
                        this.state.duration,
                        response.data[index]["TimeZoneOffset"]
                    );
                   })
        }
    addDefaultDurationGuests = (start) => {
        let retVal = new Date(start);
        retVal = new Date(
            retVal.setHours(
                retVal.getHours() + this.state.defaultSubscriptionDurationGuest
            )
        );
        return retVal;
    };
    // Prevent keyboard input on date fields - only allow calendar selection
    preventDateKeyboardInput = (e) => {
        // Allow tab for accessibility
        if (e.key === 'Tab') {
            return true;
        }
        // Prevent all other keyboard input
        e.preventDefault();
        return false;
    };
    validateEmail = (emailEntered) => {
        var mailformat = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        this.setState({
            invalidPhone: undefined,
            userFound: false,
            userFoundWithPhone: false,
        });
        let email = this.state.email.trim();
        if (!email.match(mailformat)) {
            this.setState({
                invalidEmail: "Please provide a valid email address",
            });
            $(".emailInput").addClass("is-invalid");
        } else {
            this.setState({ invalidEmail: undefined });
            $(".emailInput").removeClass("is-invalid");
        }
        this.setState({ loading: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            EmailAddress: emailEntered,
            VenueID: this.props.venueID,
        };
        axios
            .post("/venuemgmtconsole/guests/validateEmailAddress", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    firstName: response.data.GivenName,
                    lastName: response.data.FamilyName,
                    selectedLanguage: response.data.locale,
                    invalidPhone: undefined,
                    userFound: true,
                });
                if (response.data["PhoneNumber.E164"] === "") {
                    this.setState({ userFoundWithPhone: false });
                } else {
                    this.setState({
                        phoneNumber: response.data["PhoneNumber.E164"],
                        userFoundWithPhone: true,
                    });
                }
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ error: true });
                this.setState({ loading: false });
                this.setState({ userFound: false });
            });
    };
    handleSelectChangeLanguage = (value) => {
        this.setState({ selectedLanguage: value });
    };
    handleSelectChangeServicePlan = (value) => {
        if (value !== null) {
            this.setState({ selectedServicePlanID: value });
        }
    };
    submitHandlerGuest = (event) => {
        event.preventDefault();
        $("#selectVenueGuestModal").removeClass("is-invalid");
        $("#selectUnit").removeClass("is-invalid");
        $("#selectBuilding").removeClass("is-invalid");
        $("#selectFloor").removeClass("is-invalid");
        $("#selectLanguage").removeClass("is-invalid");
        event.target.className += " was-validated";
        if (this.props.venueID === undefined) {
            this.setState({ invalidVenue: "Please provide a valid venue" });
            $("#selectVenueGuestModal").addClass("is-invalid");
        } else {
            $("#selectVenueGuestModal").addClass("is-valid");
        }
        if (this.props.selectedUnit === undefined) {
            this.setState({ invalidUnit: "Please provide a valid unit" });
            $("#selectUnit").addClass("is-invalid");
        } else {
            $("#selectUnit").addClass("is-valid");
        }
        if (this.props.selectedBuilding === undefined) {
            this.setState({ invalidBuilding: "Please provide a valid unit" });
            $("#selectBuilding").addClass("is-invalid");
        } else {
            $("#selectBuilding").addClass("is-valid");
        }
        if (this.props.selectedFloor === undefined) {
            this.setState({ invalidFloor: "Please provide a valid floor" });
            $("#selectFloor").addClass("is-invalid");
        } else {
            $("#selectFloor").addClass("is-valid");
        }
        if (this.state.selectedLanguage === undefined) {
            this.setState({
                invalidLanguage: "Please provide a valid language",
            });
            $("#selectLanguage").addClass("is-invalid");
        } else {
            $("#selectLanguage").addClass("is-valid");
        }
        if (this.state.email === undefined) {
            this.setState({
                invalidEmail: "Please provide a valid email address",
            });
        }
        const startDateError = this.validateDateTime(this.state.dateStart);
        const endDateError = this.validateDateTime(this.state.dateEnd);
        if (startDateError) {
            this.setState({ invalidDateStart: startDateError });
        }
        if (endDateError) {
            this.setState({ invalidDateEnd: endDateError });
        }
        if (
            this.state.invalidEmail === undefined &&
            this.state.firstName !== undefined &&
            this.state.lastName !== undefined &&
            this.props.venueID !== undefined &&
            this.state.selectedLanguage !== undefined &&
            this.props.selectedUnit !== undefined &&
            this.props.selectedBuilding !== undefined &&
            this.props.selectedFloor !== undefined &&
            !startDateError &&
            !endDateError
        ) {
            this.props.submitHandlerGuest(
                this.props.venueID,
                this.state.dateEnd,
                this.state.email.trim(),
                this.state.firstName.trim(),
                this.state.lastName.trim(),
                this.state.phoneNumber,
                this.state.selectedLanguage,
                this.props.selectedUnit,
                this.props.selectedBuilding,
                this.props.selectedFloor,
                this.state.dateStart,
                this.props.unitID_internal,
                this.state.selectedServicePlanID,
                true,
                true
            );
        }
    };
    toggleCheckboxValueSMS = () => {
        this.setState({ sms: !this.state.sms });
    };
    toggleCheckboxValueVoice = () => {
        this.setState({ voice: !this.state.voice });
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerPhone = (event) => {
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    createMask = () => {
        this.setState({
            phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
        });
    };
    setEndDate = (dateStart, duration, timezone) => {
     console.log(duration)
        if (dateStart !== null) {
            let endDateHour;
            if (duration >= 24 || duration === 0) {
                endDateHour = new Date(dateStart.valueOf()).getHours() + 24;
            } else {
                endDateHour =
                    new Date(dateStart.valueOf()).getHours() + duration;
            }
            var endDate = new Date(dateStart).setHours(endDateHour);
            let maxDateDay;
            let maxDate;
            if (duration === 0) {
                maxDateDay = new Date(dateStart.valueOf());
                maxDate = new Date(dateStart).setHours(maxDateDay);
            } else {
                maxDateDay =
                    new Date(dateStart.valueOf()).getHours() + duration;
                maxDate = new Date(dateStart).setHours(maxDateDay);
            }
            this.setState({ maxDate: maxDate });
            if (isNaN(endDate) !== true) {
                this.setState({ dateEnd: null });
                var endDateISO = new Date(endDate).toISOString();
                if (dateStart !== null) {
                    this.setState({
                        dateEnd: Intl.DateTimeFormat("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(new Date(endDateISO)),
                    });
                }
            }
        }
    };
    validateDateTime = (value) => {
        if (!value || value.trim() === "") {
            return null;
        }
        if (/[^0-9/:, APM]/.test(value)) {
            return "Invalid characters in date/time";
        }
        if (!/^\d{2}\/\d{2}\/\d{4}, \d{1,2}:\d{2} [AP]M$/.test(value)) {
            return "Date must be in MM/DD/YYYY, h:mm AM/PM format";
        }
        const parts = value.split(", ");
        const dateParts = parts[0].split("/");
        const timeParts = parts[1].split(" ");
        const [hours, minutes] = timeParts[0].split(":");
        const period = timeParts[1];
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const hour = parseInt(hours, 10);
        const minute = parseInt(minutes, 10);
        if (month < 1 || month > 12) {
            return "Month must be between 01 and 12";
        }
        if (day < 1 || day > 31) {
            return "Day must be between 01 and 31";
        }
        if (year < 2000 || year > 2099) {
            return "Year must be between 2000 and 2099";
        }
        if (hour < 1 || hour > 12) {
            return "Hour must be between 1 and 12";
        }
        if (minute < 0 || minute > 59) {
            return "Minute must be between 00 and 59";
        }
        if (period !== "AM" && period !== "PM") {
            return "Time must end with AM or PM";
        }
        const dateObj = new Date(year, month - 1, day);
        if (
            dateObj.getFullYear() !== year ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getDate() !== day
        ) {
            return "Invalid date";
        }
        // Check if date/time is in the past
        let hour24 = hour;
        if (period === "PM" && hour !== 12) {
            hour24 = hour + 12;
        } else if (period === "AM" && hour === 12) {
            hour24 = 0;
        }
        const dateTimeObj = new Date(year, month - 1, day, hour24, minute);
        const now = new Date();
        if (dateTimeObj < now) {
            return "Date/time cannot be in the past";
        }
        return null;
    };
    validateDateTimeOnBlur = (name) => {
        const value = this.state[name];
        const error = this.validateDateTime(value);
        if (name === "dateStart") {
            this.setState({ invalidDateStart: error });
            if (!error && value) {
                this.setEndDate(value, this.props.duration, this.props.timezone);
            }
        } else if (name === "dateEnd") {
            if (!error && value && this.state.dateStart) {
                const startDate = new Date(this.state.dateStart);
                const endDate = new Date(value);
                if (endDate <= startDate) {
                    this.setState({
                        invalidDateEnd:
                            "End date must be after start date",
                    });
                    return;
                }
            }
            this.setState({ invalidDateEnd: error });
        }
    };
    handleChange = (event, { name, value }) => {
        if (this.state.hasOwnProperty(name)) {
            if (name === "dateStart" || name === "dateEnd") {
                const cleaned = value.replace(/[^0-9/:, APM]/g, "");
                this.setState({ [name]: cleaned });
                if (value !== cleaned) {
                    this.setState({
                        [name === "dateStart"
                            ? "invalidDateStart"
                            : "invalidDateEnd"]:
                            "Invalid characters in date/time",
                    });
                } else {
                    const error = this.validateDateTime(cleaned);
                    if (!error || cleaned.length < 20) {
                        this.setState({
                            [name === "dateStart"
                                ? "invalidDateStart"
                                : "invalidDateEnd"]: cleaned.length >= 20 ? error : null,
                        });
                    }
                }
            } else {
                this.setState({ [name]: value });
            }
        }
    };
    render() {
        console.log("Props for AddGuest: ", this.props)
        // console.log("State for AddGuest: ", this.state)
        const { t } = this.props;
        const FORMAT = "MM/dd/yyyy";
        return (
            <>
                {this.props.loading === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {this.props.paymentFailed ? (
                    <MDBModal
                        isOpen={this.props.paymentFailed}
                        toggle={this.props.togglePayment}
                        size="md"
                        className="form"
                        centered
                    >
                        <MDBModalHeader toggle={this.props.togglePayment}>
                            Modify Billing Credit Card Info
                        </MDBModalHeader>
                        <MDBModalBody className="error">
                            <h4>
                                The guest's credit card info needs to be
                                updated for billing purposes.
                            </h4>
                            <MDBBtn
                                color="danger"
                                className="btn Ripple-parent btn-default centered upgradePlan"
                                href={
                                    "/update/checkout?ui=" +
                                    window.location.pathname.slice(1)
                                }
                            >
                                Modify Billing CC
                            </MDBBtn>
                        </MDBModalBody>
                    </MDBModal>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggleAddGuestResubmit}>
                    <h4>Add Guest</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitHandlerGuest}
                        noValidate
                    >
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="12">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Venue Name
                                </label>
                                <SelectSearch
                                    id="selectVenue"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateVenues || []}
                                    isOptionSelected={true}
                                    inputId="venueArray"
                                    classNamePrefix="venue-select"
                                    placeholder="Select..."
                                    onChange={
                                        this.props.handleSelectChangeVenue
                                    }
                                    value={
                                        this.props.clearDropDown === true
                                            ? ""
                                            : this.props.venueID
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please select a venue.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.email")}
                                </label>
                                <input
                                    disabled
                                    id="email"
                                    className="form-control emailInput"
                                    onBlur={(event) =>
                                        this.validateEmail(this.state.email)
                                    }
                                    onChange={(event) =>
                                        this.setState({
                                            email: event.target.value,
                                        })
                                    }
                                    value={this.state.email}
                                    error={
                                        this.state.invalidEmail !== undefined
                                            ? "Invalid email address"
                                            : "Email address required"
                                    }
                                />
                                {this.state.invalidEmail !== undefined ? (
                                    <div className="invalid">
                                        {this.state.invalidEmail}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.firstname")}
                                </label>
                                <input
                                    disabled
                                    name="firstName"
                                    id="firstName"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    onChange={this.changeHandler}
                                    value={this.state.firstName}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid first name.
                                </div>
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.lastname")}
                                </label>
                                <input
                                    disabled
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    name="lastName"
                                    id="lastName"
                                    onChange={this.changeHandler}
                                    value={this.state.lastName}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid last name.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.phone")}
                                </label>
                                <PhoneInput
                                    placeholder={t("addnewguest.enterphone")}
                                    value={this.state.phoneNumber}
                                    format={FORMAT}
                                    onChange={this.changeHandlerPhone}
                                    name="phoneNumber"
                                    id="phoneNumber"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    defaultCountry="US"
                                    required
                                    error={
                                        this.state.phoneNumber
                                            ? isValidPhoneNumber(
                                                  this.state.phoneNumber
                                              )
                                                ? undefined
                                                : "Invalid phone number"
                                            : "Phone number required"
                                    }
                                    disabled
                                />
                                {this.state.invalidPhone !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidPhone}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol col="6">
                                <div>
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        {t("addnewresident.language")}
                                    </label>
                                    <input
                                        disabled={true}
                                        // id="selectLanguage"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        className={
                                            this.state.loading === true
                                                ? "form-control loading"
                                                : "form-control"
                                        }
                                        value={
                                            this.state.selectedLanguage ===
                                            "en-us"
                                                ? "English"
                                                : "Spanish"
                                        }
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid language.
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.unit")}
                                </label>
                                <SelectSearch
                                    id="selectUnit"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateGuestUnits}
                                    onChange={this.props.handleSelectChangeUnit}
                                    isOptionSelected={true}
                                    inputId="unitArray"
                                    classNamePrefix="unit-select form-control"
                                    placeholder="Select..."
                                    value={this.props.selectedUnit}
                                />
                                <div className="invalid-feedback">
                                    Please provide a unit number.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Building
                                </label>
                                <SelectSearch
                                    id="selectUnit"
                                    options={this.props.optionTemplateBuilding}
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    onChange={
                                        this.props.handleSelectChangeBuilding
                                    }
                                    isOptionSelected={true}
                                    inputId="buildingArray"
                                    classNamePrefix="building-select"
                                    placeholder="Select..."
                                    value={this.props.selectedBuilding}
                                />
                                <div className="invalid-feedback">
                                    Please provide a building.
                                </div>
                            </MDBCol>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Floor
                                </label>
                                <SelectSearch
                                    // ref={this.floorSelect}
                                    id="selectUnit"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateFloor || []}
                                    onChange={
                                        this.props.handleSelectChangeFloor
                                    }
                                    isOptionSelected={true}
                                    inputId="floorArray"
                                    classNamePrefix="floo-select"
                                    placeholder="Select..."
                                    value={this.props.selectedFloor}
                                />
                                <div className="invalid-feedback">
                                    Please provide a floor.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Service Plan
                                </label>
                                <SelectSearch
                                    ref={this.servicePlanSelect}
                                    id="selectServicePlan"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={
                                        this.props.optionTemplateServicePlans || []
                                    }
                                    onChange={
                                        this.handleSelectChangeServicePlan
                                    }
                                    isOptionSelected={true}
                                    inputId="floorArray"
                                    classNamePrefix="floo-select"
                                    placeholder="Select..."
                                    emptyMessage="Select..."
                                    value={this.state.selectedServicePlanID}
                                />
                                <div className="invalid-feedback">
                                    Please provide a service plan.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.servicestart")}
                                </label>
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateStart"
                                    placeholder="MM/DD/YYYY"
                                    value={this.state.dateStart}
                                    iconPosition="left"
                                    onChange={this.handleChange}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateStart")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className={"dateTimePicker" + (this.state.invalidDateStart ? " error" : "")}
                                    closable={true}
                                    disableMinute="true"
                                    minDate={this.props.dateStartNow}
                                    maxDate={new Date(this.state.maxDate)}
                                />
                                {this.state.invalidDateStart && (
                                    <div className="invalid" style={{ color: "red", fontSize: "12px" }}>
                                        {this.state.invalidDateStart}
                                    </div>
                                )}
                                <label
                                    for="serviceStart"
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "absolute",
                                        top: this.state.invalidDateStart ? "80px" : "65px",
                                        left: "15px",
                                    }}
                                >
                                    {this.props.venueType === "HOTSPOT"
                                        ? "Guest can use their Wi-Fi password as of this date"
                                        : t("addnewguest.servicestartlabel")}
                                </label>
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.serviceend")}
                                </label>
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateEnd"
                                    placeholder="MM/DD/YYYY"
                                    value={this.state.dateEnd}
                                    iconPosition="left"
                                    onChange={this.handleChange}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateEnd")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className={"dateTimePicker" + (this.state.invalidDateEnd ? " error" : "")}
                                    closable={true}
                                    disableMinute="true"
                                    maxDate={
                                        this.state.duration === 0
                                            ? "0"
                                            : new Date(this.state.maxDate)
                                    }
                                    minDate={new Date(this.state.dateStart)}
                                />
                                {this.state.invalidDateEnd && (
                                    <div className="invalid" style={{ color: "red", fontSize: "12px" }}>
                                        {this.state.invalidDateEnd}
                                    </div>
                                )}
                                <label
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "absolute",
                                        top: this.state.invalidDateEnd ? "80px" : "65px",
                                        left: "15px",
                                    }}
                                >
                                    {t("addnewguest.serviceendlabel")}
                                </label>
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn color="danger" type="submit">
                                {this.props.loadingRecreateSubscription ===
                                true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : this.props.venueType === "HOTSPOT" ? (
                                    "Add Guest Policy"
                                ) : (
                                    t("addnewguest.addguest")
                                )}
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}
export default withTranslation()(AddNewGuest);
